module.exports = __webpack_public_path__ + "static/media/39_Management_Committee.590173d6.JPG";